import React, { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { mainBox } from "../../assets/Variables/SpaceVariables.js";
import * as TextVariables from "../../assets/Variables/TextVariables.js";
import { useCookies } from "../../Tools/CookieChecker.js";
import ProfileCard from "../../components/Cards/ProfileCard.js";
import WalletRequest from "../../Endpoints/WalletRequest.js";
import { GetDashboardData } from "../../Tools/LocalStorage.js";
import CardBackOffice from "../../components/Cards/CardBackOffice.js";

const settingsOptions = [
  {
    title: "Your password settings",
    linkTo: "/settings/password",
    icon: "password",
    visible: true
  },
  {
    title: "Your mailing subscriptions",
    linkTo: "/settings/mail-suscriptions",
    icon: "mail",
    visible: false
  },
  {
    title: "Your email settings",
    linkTo: "/settings/email-settings",
    icon: "mail_lock",
    visible: false
  },
  {
    title: "Set your 2-factor authentication",
    linkTo: "/settings/two-factor-auth",
    icon: "encrypted",
    visible: false
  }
];

function SettingsPage(props) {
  const { user, name, type, currency } = useCookies();

  const [avatarInfo, setAvatarInfo] = useState({
    color: "",
    letter: ""
  });

  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    type: "",
    balance: 0,
    asset: "USD",
    clients: 0
  });

  const CalculateAvatarValues = (string) => {
    let color = "#";
    let hash = 0;

    for (let i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    for (let i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    setAvatarInfo({
      color,
      letter: string.split(" ")[0][0]
    });
  };

  const RequestWalletData = async () => {
    try {
      const response = await WalletRequest();

      if (response.data.data != null) {
        setUserInfo((prevState) => ({
          ...prevState,
          balance: parseFloat(
            response.data.data.wallet.balance
          ).toFixed(2),
          asset: response.data.data.wallet.currency
        }));
      } else {
        setUserInfo((prevState) => ({
          ...prevState,
          balance: 0,
          asset: ""
        }));
      }
    } catch (error) {
      setUserInfo((prevState) => ({
        ...prevState,
        balance: 0,
        asset: ""
      }));

      console.log(error);
    }
  };

  useEffect(() => {
    if (user) {
      CalculateAvatarValues(name);

      const dashboardData = GetDashboardData();

      setUserInfo({
        name,
        email: user,
        type,
        balance: 0,
        asset: "",
        clients: dashboardData?.dashboard?.total_accounts || 0
      });

      RequestWalletData();
    }
  }, [user]);

  return (
    <Box
      sx={{
        ...mainBox,
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
        px: {
          xs: 1,
          sm: 2,
          md: 3
        }
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: "80%",
          maxWidth: "1300px",
          boxSizing: "border-box",
          p: {
            xs: 2,
            sm: 3
          },
          borderRadius: "8px",
          overflow: "hidden"
        }}
      >
        {/* Header */}
        <Box
          sx={{
            mb: {
              xs: 3,
              sm: 4
            }
          }}
        >
          <Typography
            sx={{
              ...TextVariables.Subtitle_4,
              fontSize: {
                xs: "1.1rem",
                sm: "1.25rem"
              }
            }}
            gutterBottom
          >
            Your account preferences
          </Typography>

          <Typography
            sx={{
              ...TextVariables.Body_4,
              fontSize: {
                xs: "0.875rem",
                sm: "1rem"
              }
            }}
            color="text.secondary"
          >
            Welcome this is your profile page. Here you can see your
            clients and their movements.
          </Typography>
        </Box>

        {/* Main content */}
        <Grid
          container
          spacing={{
            xs: 2,
            sm: 3
          }}
        >
          {/* Profile */}
          <Grid
            item
            xs={12}
            md={12}
            lg={4}
            sx={{
              minWidth: "300px"
            }}
          >
            <ProfileCard
              avatarInfo={avatarInfo}
              userInfo={userInfo}
              currency={userInfo.asset || currency}
            />
          </Grid>

          {/* Settings */}
          <Grid
            item
            xs={12}
            md={12}
            lg={8}
            sx={{
              minWidth: 0
            }}
          >
            <Grid
              container
              spacing={{
                xs: 2,
                sm: 2
              }}
            >
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...TextVariables.Body_3_bold,
                    fontSize: {
                      xs: "0.95rem",
                      sm: "1rem"
                    }
                  }}
                  gutterBottom
                >
                  Set your account preferences
                </Typography>
              </Grid>

              {settingsOptions
                .filter((value) => value.visible)
                .map((value, index) => (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    sx={{
                      minWidth: 0
                    }}
                  >
                    <CardBackOffice
                      _icon={value.icon}
                      title={value.title}
                      linkTo={value.linkTo}
                      visible={value.visible}
                    />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>

        <Box
          sx={{
            mb: {
              xs: 4,
              sm: 8,
              md: 12
            }
          }}
        />
      </Paper>
    </Box>
  );
}

export default SettingsPage;